import React from "react";

const LoadingDiv = ({}) => {
  return (
    <div className="flex items-center justify-center py-20">
      <div
        className="w-10 h-10 border-4 border-t-transparent rounded-full animate-spin"
        style={{ borderColor: "#16a12a", borderTopColor: "transparent" }}
      ></div>
    </div>
  );
};

export default LoadingDiv;
